<template>
  <CustomModal
    id="modal-insufficient-permissions"
    class="modal modal--large modal--theme-custom modal-insufficient-permissions"
  >
    <template #header>
      <BaseHeading
        level="3"
        class="modal__heading"
      >
        <img
          :src="require('@/assets/images/icons/alert-triangle.svg')"
          width="var(--icon-20)"
          height="var(--icon-16)"
          class="modal__alert-icon"
        />
        Insufficient Permissions
      </BaseHeading>
    </template>

    <template #body>
      <BaseSubHeading
        size="large"
        weight="400"
        color="monochrome-06"
        class="modal__subheading"
      >
        Please request Admin access from your Administrator to {{ checkPermissions.action }}
        {{ checkPermissions.type }}
      </BaseSubHeading>
    </template>

    <template #footer>
      <ControlButtons
        class="modal__buttons"
        :hideCancel="true"
        @save="onApply"
      >
        <template #save> Ok </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from "vue"
import { useStore } from "vuex"

import ControlButtons from "@/components/ControlButtons/index.vue"
import CustomModal from "@/components/Modal/index.vue"

import { PermissionTypes } from "@/models/PermissionsType"
import { Actions, Getters } from "@/store"

const { proxy } = getCurrentInstance()!
const store = useStore()

const checkPermissions = computed(() => store.getters[Getters["CHECK_PERMISSION"]])

const onApply = () => {
  proxy.$modal.hide("modal-insufficient-permissions")
}
</script>

<style lang="scss">
.modal-insufficient-permissions {
  .custom-modal {
    width: 512px;
    padding: var(--step6);

    @media (max-width: 1536px) {
      width: 440px;
      padding: var(--step5);
    }

    @media (max-width: 1280px) {
      width: 384px;
    }
  }

  .modal__heading {
    display: flex;
    align-items: center;
    margin-bottom: var(--step6);

    @media (max-width: 1366px) {
      margin-bottom: var(--step5);
    }
  }

  .modal__alert-icon {
    margin-right: var(--step1);
  }

  .modal__subheading {
    margin-top: var(--step4);
  }

  .modal__buttons {
    margin-top: var(--step5);
  }

  .content__control-buttons__save {
    min-width: 70px;
    height: 48px;
    padding: 0;

    @media (max-width: 1366px) {
      min-width: 60px;
      height: 38px;
    }

    @media (max-width: 1280px) {
      min-width: 57px;
      height: 36px;
    }
  }
}
</style>
